export default __webpack_public_path__ + "static/media/Dazzed-Heavy.588fdd3c.otf";